import { OnboardingPage } from '~/components/pages/OnboardingPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';

export const RegionOnboardingRoute: React.FC = () => (
  <DashboardTemplate>
    <OnboardingPage />
  </DashboardTemplate>
);
